import { createI18n } from 'vue-i18n';
import nl from './locales/nl';
import de from './locales/de';

// Start with the default locale. App.vue applies authStore.agentLang reactively
// after authentication resolves, so no store access is needed here.
const i18n = createI18n({
  legacy: false,
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: {
    nl,
    de,
  },
});

export default i18n;
